import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
interface QuoteModalValue {
  isOpen: boolean;
  openQuote: () => void;
  closeQuote: () => void;
  hasBeenOpened: boolean;
}
const QuoteModalContext = createContext<QuoteModalValue | null>(null);
export function QuoteModalProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const openQuote = useCallback(() => {
    setIsOpen(true);
    setHasBeenOpened(true);
  }, []);
  const closeQuote = useCallback(() => setIsOpen(false), []);
  const value = useMemo(() => ({
    isOpen,
    openQuote,
    closeQuote,
    hasBeenOpened
  }), [isOpen, openQuote, closeQuote, hasBeenOpened]);
  return <QuoteModalContext.Provider value={value} data-id="element-387" data-mp="2u6z44duans6z">{children}</QuoteModalContext.Provider>;
}
export function useQuoteModal(): QuoteModalValue {
  const context = useContext(QuoteModalContext);
  if (!context) {
    throw new Error('useQuoteModal must be used inside a QuoteModalProvider');
  }
  return context;
}